import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-stone-50 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-101" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-102" data-mp="9tl7qu9ytdsq">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-stone-200 bg-white p-8 shadow-lg shadow-stone-900/10 sm:p-12" data-id="element-103" data-mp="et620re6wxz4">
          <span className="inline-flex rounded-full border-4 border-amber-500 bg-emerald-800 p-4 text-amber-400" data-id="element-104" data-mp="slvvfgw1t569">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-105" data-mp="xjfin6aq4sac" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-emerald-950" data-id="element-106" data-mp="12kbin8ryfuah">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-stone-800" data-id="element-107" data-mp="25rx9godmuvzi">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-emerald-900 px-5 py-4 text-lg font-extrabold text-stone-50" data-id="element-108" data-mp="1vvtx6pp2hgyu">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-stone-700" data-id="element-109" data-mp="2jjbsgv7jix6k">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}